export const appVersion = require("../version.json").app_version;

const iconNames = {
  dashboard: "dashboard",
  testupload: "testupload",
  faq: "faq",
  reports: "reports",
  extracts: "extracts",
  program: "program",
  home: "home",
  clients: "clients",
  user: "user",
  eligiblePopulation: "eligible_population",
  dataFeeds: "data_feeds",
  emailTemplate: "email_template",
  logs: "logs",
  security: "security"
};

const instructions = {
  duplicated: "Duplicate",
  delete: "Delete",
  edit: "Edit",
  submit: "Submit"
};

const LOCAL_STORE = {
  accessToken: "access_token",
  refreshToken: "refresh_token",
  refreshTokenAt: "refresh_token_at",
  pagingOptions: "cc_pagingOptions",
  uid: "uid",
  client: "client",
  programTabIndex: 1,
  incentiveProcessingTabIndex: "incentive_processing_tab_index",
  transactionOnWait: "transaction_on_wait",
  transactionIsTested: "transaction_is_tested",
  permission: "permission"
};

const TIMEOUT_VARIABLES = {
  INACTIVE_USER_TIME_THRESHOLD: 900000,
  USER_ACTIVITY_THROTTLER_TIME: 1000,
  USER_ACTIVITY_TTL_FACTOR: .45
};

const modalAction = {
  deleteEmployer: "deleteEmployer",
  showEmployeeFileHistory: "showEmployeeFileHistory",
  showProcessingFileErrorList: "showProcessingFileErrorList",
  deleteFileSource: "deleteFileSource",
  deleteCertificate: "deleteCertificate",
  terminateEmployee: "terminateEmployee",
  reinstateEmployee: "reinstateEmployee",
  blockUser: "blockUser",
  reInviteUser: "reInviteUser",
  removeCustomActivity: "removeCustomActivity",
  confirmDeletionActivityPhase: "confirmDeletionActivityPhase",
  confirmDeletionLevelPath: "confirmDeletionLevelPath",
  bulkAddActivities: "bulkAddActivities",
  removeRewardAccessToken: "removeRewardAccessToken",
  openLogoModal: "openLogoModal",
  deleteConsent: "deleteConsent"
};

const mappingModalActionToModalData = {
  deleteEmployer: {
    title: "Delete Employer",
    modalAction: modalAction.deleteEmployer,
    showFooter: true,
    closeButton: false,
    btnRight: "Delete Employer",
    btnLeft: "Cancel",
    height: 290
  },
  showEmployeeFileHistory: {
    title: "File History",
    modalAction: modalAction.showEmployeeFileHistory,
    showFooter: false,
    closeButton: true,
    btnRight: "Ok",
    btnLeft: "Cancel",
    height: "auto"
  },
  showProcessingFileErrorList: {
    title: "Upload errors",
    modalAction: modalAction.showProcessingFileErrorList,
    showFooter: false,
    closeButton: true,
    btnRight: "Ok",
    btnLeft: "Cancel",
    height: "auto",
    customClass: 'upload-errors-modal'
  },
  deleteFileSource: {
    title: "Delete File Source",
    modalAction: modalAction.deleteFileSource,
    showFooter: true,
    closeButton: false,
    btnRight: "Delete File Source",
    btnLeft: "Cancel",
    height: 290
  },
  deleteCertificate: {
    title: "Delete Certificate",
    modalAction: modalAction.deleteCertificate,
    showFooter: true,
    closeButton: false,
    btnRight: "Delete Certificate",
    btnLeft: "Cancel",
    height: 290
  },
  terminateEmployee: {
    title: "Terminate Employee",
    modalAction: modalAction.terminateEmployee,
    showFooter: true,
    closeButton: false,
    btnRight: "Yes",
    btnLeft: "No",
    height: 290
  },
  reinstateEmployee: {
    title: "Reinstate Employee",
    modalAction: modalAction.reinstateEmployee,
    showFooter: true,
    closeButton: false,
    btnRight: "Yes",
    btnLeft: "No",
    height: 290
  },
  blockUser: {
    title: "Block User",
    modalAction: modalAction.blockUser,
    showFooter: true,
    closeButton: false,
    btnRight: "Yes",
    btnLeft: "No",
    height: 290
  },
  reInviteUser: {
    title: "Reinvite User",
    modalAction: modalAction.reInviteUser,
    showFooter: true,
    closeButton: false,
    btnRight: "Yes",
    btnLeft: "No",
    height: 290
  },
  removeCustomActivity: {
    title: "Remove Activity",
    modalAction: modalAction.removeCustomActivity,
    showFooter: true,
    closeButton: false,
    btnRight: "Yes",
    btnLeft: "No",
    height: 290
  },
  confirmDeletionActivityPhase: {
    title: "Confirm Deletion",
    modalAction: modalAction.confirmDeletionActivityPhase,
    showFooter: true,
    closeButton: false,
    btnRight: "Yes",
    btnLeft: "No",
    height: 290
  },
  confirmDeletionLevelPath: {
    title: "Confirm Deletion",
    modalAction: modalAction.confirmDeletionLevelPath,
    showFooter: true,
    closeButton: false,
    btnRight: "Yes",
    btnLeft: "No",
    height: 290
  },
  removeRewardAccessToken: {
    title: "Remove Reward Access Token",
    modalAction: modalAction.removeRewardAccessToken,
    showFooter: true,
    closeButton: false,
    btnRight: "Yes",
    btnLeft: "No",
    height: 290
  },
  bulkAddActivities: {
    title: "Bulk Add Activities",
    modalAction: modalAction.bulkAddActivities,
    showFooter: true,
    closeButton: false,
    btnRight: "Yes",
    btnLeft: "No",
    height: 290
  },
  openLogoModal: {
    title: "Edit company logo",
    modalAction: modalAction.openLogoModal,
    showFooter: true,
    closeButton: false,
    btnRight: "Yes",
    btnLeft: "No",
  },
  deleteConsent: {
    title: "Delete Consent",
    modalAction: modalAction.deleteConsent,
    showFooter: true,
    closeButton: false,
    btnRight: "Yes",
    btnLeft: "Cancel",
    height: 290
  }
};

const activityActions = {
  add: "Add",
  edit: "Edit",
  delete: "Delete",
  upload: 'Upload',
  extracts: 'Extracts'
};

const fileProcessing = {
  completed: {
    code: "completed_no_errors",
    class: "file-process-icon completed",
    text: "Completed"
  },
  completeWithError: {
    code: "completed_with_errors",
    class: "file-process-icon completed-error",
    text: "Completed with errors"
  },
  notCompleted: {
    code: "not_completed",
    class: "file-process-icon failed",
    text: "Not Completed"
  },
  failed: {
    code: "failed",
    class: "file-process-icon failed",
    text: "Failed"
  },
  in_progress: {
    code: "in_progress",
    class: "file-process-icon in-progress",
    text: "In progress"
  },
  uploaded_s3: {
    code: "s3",
    class: "file-process-icon s3",
    text: "Scheduled"
  },
  scheduled: {
    code: "scheduled",
    class: "file-process-icon s3",
    text: "Scheduled"
  },
  open: {
    code: "open",
    class: "file-process-icon s3",
    text: "Scheduled"
  },
  pentaho: {
    code: "pentaho",
    class: "file-process-icon s3",
    text: "Scheduled"
  }
};

const incentiveReportType = {
  point: "incentive_points_data",
  reward: "incentive_events_data",
  event_challenge: "event_challenge",
  custom: "custom"
};

const uploadFileType = {
  eligibility: "eligibility_data",
  biometrics: "biometrics_data",
  incentive: "incentive_points_data"
};

const reportSearchRibbon = {
  tabList: {
    Platform: 0,
    Wellmetrics: 1,
    HumanPerformance: 2,
    ComparisonReport: 3,
    PlatformLookback: 4,
    WellmetricsLookback: 5
  }
};

const chartType = {
  Pie: "pie",
  Column: "column",
  Line: "spline",
  Bar: "bar"
};

const gaCustomDimension = {
  searchText: "dimension3",
  filterUrl: "dimension2",
  userId: "dimension4",
  userRole: "dimension5",
  userName: "dimension6",
  tabName: "dimension7"
};

const clientServicesConfiguration = {
  engagement: "engagement",
  wellmetrics: "wellmetrics",
  coaching: "coaching"
};

const accountRoles = {
  admin: "admin",
  accountManager: "account_manager"
};

export const entities = {
  password: "password",
  report_generation: "report_generation",
  sftp: "sftp",
  role: "role",
  employee: "employee",
  data_transaction: "data_transaction",
  file_process: "file_process",
  user: "user",
  query_result: "query_result",
  employer_sftp: "data_feed",
  report_category: "report_category",
  provider: "provider",
  employer: "employer",
  certificate: "certificate",
  permission: "permission",
  report_filter: "report_filter",
  program: "program",
  programTemplate: "program_template",
  programBasicInfo: "program_basic_info",
  programDates: "program_program_dates",
  programPointStructure: "program_point_structure",
  programMilestoneSettings: "program",
  programMilestoneCompletionRewards: "program",
  programOutcomesLite: "program_healthy_ranges",
  programAppealsForm: "program_appeals_form",
  programTobacco: "program_tobacco_surcharge_management",
  programPointsOverview: "program_points_overview",
  programActivity: "program_activity_calendar",
  programLevelActivities: "program_required_level_activities_paths",
  programRas: "program_reasonable_alternative_standards",
  programLevelRewards: "program_level_rewards",
  email_template: "email_template",
  activities_log: "activity_logs",
  extract: "extracts",
  programCollection: "program_collections",
  programCohorts: "program_cohorts",
  policy_manage: "policy_manage",
  blocked_domain_manage: "blocked_domain_manage",
  user_client_admin: "user_client_admin",
  program_cohorts: "program_cohorts",
  program_collections: "program_collections",
  system: "system",
  report: "report"
};

export const panels = {
  client: "client",
  admin: "admin"
};

export const typeOptions = [
  { text: "Inbound", id: "inbound" },
  { text: "Outbound", id: "outbound" }
];

const dataTypeOptions = [
  { text: "Eligibility Data", id: "eligibility_data" },
  { text: "Unknown Export To Egnyte", id: "unknown_export_to_egnyte" },
  { text: "Query Result", id: "query_result" },
  { text: "Biometrics Data", id: "biometrics_data" },
  { text: "Incentive Data", id: "incentive_points_data" }
];

export const columnMappingDataTypeOptions = [
  { text: "Eligibility Data", id: "eligibility_data" },
  { text: "Biometrics Data", id: "biometrics_data" },
  { text: "Incentive Data", id: "incentive_points_data" }
];

const columnMappingOptions = {
  eligibility_data: [
    "employer_name",
    "first_name",
    "last_name",
    "email",
    "phone",
    "ssn",
    "employee_id",
    "postal_code",
    "job_code",
    "division",
    "group_code",
    "country",
    "health_plan",
    "location",
    "region",
    "store",
    "age_range",
    "bargaining_unit",
    "class",
    "current_walking",
    "department",
    "district",
    "facility",
    "gender",
    "status",
    "birth_date",
    "terminated_date",
    "relationship",
    "subscriber_id",
    "address1",
    "address2",
    "city",
    "state",
    "ignore_omitted",
    "hire_date",
    "new_hire",
    "language",
    "dental",
    "vision",
    "union",
    "executive"
  ],
  biometrics_data: [],
  incentive_points_data: [
    "employer_name",
    "employeeId",
    "activityCode",
    "createdDate"
  ]
};

const genderOptions = [
  { id: "unknown", text: "Unknown" },
  { id: "male", text: "Male" },
  { id: "female", text: "Female" }
];

const relationshipOptions = [
  { id: "employee", text: "0" },
  { id: "spouse", text: "1" },
  { id: "dependent_1", text: "2" },
  { id: "dependent_2", text: "3" }
];

export const relationshipCodes = {
  0: "employee",
  1: "spouse",
  2: "dependent_1",
  3: "dependent_2"
};

const loadingStatus = {
  INITIAL: 0,
  LOADING: 1,
  LOADED: 2
};

const challengeMFA = {
  LOGIN: "LOGIN",
  SMS_MFA: "SMS_MFA",
  SETUP_MFA: "SETUP_MFA",
  NEW_PASSWORD_CHALLENGE: "NEW_PASSWORD_CHALLENGE",
  FORCE_CHANGE_PASSWORD: "FORCE_CHANGE_PASSWORD",
  PWD_CONFIRMED: "pwd_ready_confirmed",
  COGNITO_STATUS_CONFIRM: "CONFIRMED"
};

const userStatus = {
  FORCE_CHANGE_PASSWORD: "FORCE_CHANGE_PASSWORD",
  CONFIRMED: "CONFIRMED"
};

const directToEmployerStatus = {
  ELIGIBLE: "eligible",
  SENT_REGISTRATION_EMAIL: "sent_registration_email",
  REGISTERED_FOR_PLATFORM: "registered_for_platform",
  SCHEDULED_SCREENING: "scheduled_screening",
  SCREENED: "screened"
};

const PW_REGEX = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`])([a-zA-Z0-9^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`]){8,}$/;

export const operators = ["=", ">", "<", ">=", "<="];
export const subGroupFieldsWithOperator = ["hire_date"];
export const subGroupDateFields = ["hire_date"];
export const subGroupFieldsOnForm = [
  "country",
  "age_range",
  "region",
  "location",
  "relationship"
];
export const userProvisioning = {
  requestType: {
    CREATE_NEW_ADMIN: {
      CODE: "create_new_admin",
      TEXT: "Create New Admin"
    },
    UPDATE: {
      CODE: "update",
      TEXT: "Update"
    },
    BLOCK_ACCESS: {
      CODE: "block_access",
      TEXT: "Block Access"
    }
  }
};

export const pointEconomyPercentage = 15;

export default {
  appVersion: appVersion,
  iconNames: iconNames,
  LOCAL_STORE: LOCAL_STORE,
  TIMEOUT_VARIABLES: TIMEOUT_VARIABLES,
  instructions,
  modalAction,
  mappingModalActionToModalData,
  fileProcessing,
  incentiveReportType,
  uploadFileType,
  reportSearchRibbon,
  chartType,
  gaCustomDimension,
  clientServicesConfiguration,
  accountRoles,
  entities,
  panels,
  typeOptions,
  dataTypeOptions,
  loadingStatus,
  challengeMFA,
  PW_REGEX,
  genderOptions,
  relationshipOptions,
  userStatus,
  directToEmployerStatus,
  activityActions,
  columnMappingDataTypeOptions,
  columnMappingOptions,
  operators,
  subGroupFieldsWithOperator,
  subGroupDateFields,
  subGroupFieldsOnForm,
  pointEconomyPercentage
};



// WEBPACK FOOTER //
// ./src/_consts.js